
import {  useTranslation } from 'react-i18next';
import StepHeader from './StepHeader';
import StepContent from './StepContent';
import StepWrapper from './StepWrapper';
import { P } from '../../../components/Typography';
import { ButtonLink } from '../../../components/Buttons';

type ConnectionsStepProps ={
    current: number;
}

const step = 2;

const ConnectionsStep = (
    {
        current,
    }: ConnectionsStepProps
) => {
    const { t } = useTranslation();
    return (
        <StepWrapper>
            <StepHeader title={t('wizards.checkout.connections_step.title')} step={step} current={current} />
            {current === step && (
                <StepContent>
                    <>
                        <P>
                            {t('wizards.checkout.connections_step.no_connections_description')}
                        </P>
                        <br />
                        <ButtonLink to="../settings/payment-connections">
                            {t('wizards.checkout.connections_step.call_to_action')}
                        </ButtonLink>
                    </>
                </StepContent>
            )}
        </StepWrapper>
    );
};

export default ConnectionsStep;
